import { render, staticRenderFns } from "./BaseStats.vue?vue&type=template&id=fa4950b4&"
import script from "./BaseStats.vue?vue&type=script&lang=js&"
export * from "./BaseStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports